/* eslint-disable @typescript-eslint/no-explicit-any */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { ToastModule } from 'src/app/components/toast/toast.module';
import { CommonModalService } from '../../events/services/common-modal.service';
import { TranslationService } from 'src/app/shared/service/translation.service';
import { DataServiceServiceProfile } from '../services/profile-data-service.service';
import { AppConstants } from 'src/app/shared/constants/constants';
import { ToastService, ToastType } from 'src/app/shared/service/toast.service';
import { LoadingSpinnerService } from 'src/app/shared/service/loading-spinner.service';
@Component({
  selector: 'app-create-edit-profile',
  templateUrl: './create-edit-profile.component.html',
  styleUrls: ['./create-edit-profile.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, ReactiveFormsModule, TranslateModule, SharedModule, ToastModule],
})
export class CreateEditProfileComponent implements OnInit {
  private readonly commonModalService = inject(CommonModalService);
  private readonly fb = inject(UntypedFormBuilder);
  private readonly translationService = inject(TranslationService);
  private readonly profileDataService = inject(DataServiceServiceProfile);
  private readonly toastService = inject(ToastService);
  private readonly _loadingSpinnerService = inject(LoadingSpinnerService);
  private readonly _cdr = inject(ChangeDetectorRef);
  private readonly _destroyRef = inject(DestroyRef);
  public aliasForm!: UntypedFormGroup;
  @ViewChild('editPopup') editPopup: TemplateRef<any> | undefined;
  showEditPopup: boolean = true
  popupType: string = 'large-popup'
  imageUrl: any
  fileToUpload: any;
  translationData: any;
  public buttonNames: any = AppConstants.COMMON_BUTTON_LABELS;
  public appConstants = AppConstants;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  maintainAspectRatio: boolean = true;
  aspectRatio: number = 1;
  containWithinAspectRatio: boolean = false;
  cropperMinWidth: number = 176;
  cropperMinHeight: number = 176;
  maxImageSize: number = 5000000;
  minImageSize: number = 176;
  imageName: string = ''
  isHeaderVisible: boolean = true
  formSubmitted: boolean = false
  initialFormValues: any;
  imageSizeIsSmall: boolean = false
  imageSizeIsLarge: boolean = false
  showToast = false;
  toastMessage: any;
  position: any;
  toastType: any;
  leftPosition: any;

  @Output() cancelClicked = new EventEmitter<any>();
  @Output() getMemberListData = new EventEmitter<string>();
  @Input() profileData: any;

  ngOnInit(): void {
    this.commonModalService._modalHeaderIsCloseBtnVisible.next(true)
    this.commonModalService._modalHeaderIsSaveBtnVisible.next(true)
    this.commonModalService._modalHeaderTitle.next('BP_PM_EDIT_PROFILE')
    this.imageUrl = localStorage.getItem('profileImage') ?? this.profileData?.profileImageUrl;

    this.aliasForm = this.fb.group({
      'profileName': [this.profileData?.profileName, Validators.required],
      'profileDescription': [this.profileData?.profileDescription, [Validators.required, Validators.maxLength(256)]],
      'businessWebsite': [this.profileData?.businessWebsite, [Validators.required, this.urlValidation]],
      'profileImageDeletion': ["false"]
    })

    this.initialFormValues = { ...this.aliasForm.value };

    this.toastService.toastDetails
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((status: any) => {
        this.showToast = status?.isShown;
        this.toastMessage = status?.message;
        this.toastType = status?.toastType;
        this.position = status?.position;
        this.leftPosition = status?.leftPosition;
        this._cdr.markForCheck();
      });
  }

  urlValidation(control: any) {
    const url = control.value;
    // Regex to match a valid URL with or without protocol (http, https, ftp, etc.)
    const regex = AppConstants.URL_VALIDATION_REGEX_PATTERN

    return regex.test(url) ? null : { invalidUrl: true };
  }
  public saveProfileData(): void {
    this.formSubmitted = true;
    if (this.aliasForm.valid && this.isFormChanged()) {
      this._loadingSpinnerService.show()
      const payload =
      {
        profileName: this.aliasForm.value.profileName,
        profileDescription: this.aliasForm.value.profileDescription,
        businessWebsite: this.aliasForm.value.businessWebsite,
        profileImageDeletion: "false"
      }
      this.profileDataService.updateProfile(payload, this.aliasForm.value.uploadedImage).subscribe(
        (data: any) => {
          const profileImageUrl = data.body.profileImageUrl
          const profileName = data.body.profileName
          this.showEditPopup = false
          this.cancelClicked.emit(true)
          this.getMemberListData.emit(data.body);
          localStorage.setItem('profileName', profileName)
          localStorage.setItem('profileImage', profileImageUrl)
          this._cdr.markForCheck();
        }
      )
    }
  }

  handleFileInput(event: any) {
    this._loadingSpinnerService.show()
    const fileInput = event.target as HTMLInputElement;
    const file = event.target.files[0];
    const fileName = file.name;
    const fileSize = file.size
    this.checkFileType(fileName)
    if (file) {
      this.imageChangedEvent = event;
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.imageChangedEvent = e.target?.result;
        fileInput.value = '';
        const img = new Image();
        img.src = e.target?.result;
        img.onload = () => {
          const imageWidth = img.width;
          const imageHeight = img.height;
          this.checkFileValidation(imageWidth, imageHeight, fileSize)
        };
      };

      reader.readAsDataURL(file);
    }

  }
  closeModal() {
    this.showEditPopup = false
    this.cancelClicked.emit(true)
  }
  closeCropperModal() {
    const modal = document.getElementById("cropModal");
    if (modal) {
      modal.style.display = "none";
    }
    this.imageSizeIsSmall = false;
    this.imageSizeIsLarge = false;
  }

  onCropped(event: any) {
    this.croppedImage = event.base64;
  }

  onImageLoaded() {
    const modal = document.getElementById("cropModal");
    if (modal) {
      modal.style.display = "block";
    }
    this._loadingSpinnerService.hide()
  }

  loadProfilePicture() {
    this.fileToUpload = this.croppedImage
    this.imageUrl = this.croppedImage
    const converToBlob = this.b64toBlob(this.croppedImage);
    this.aliasForm.addControl('uploadedImage', new UntypedFormControl(converToBlob))
    this.closeCropperModal()
  }

  b64toBlob(dataURI: any) {
    const byteString: string = atob(dataURI.split(',')[1]);
    const ab: ArrayBuffer = new ArrayBuffer(byteString.length);
    const ia: Uint8Array = new Uint8Array(ab);

    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: 'image/jpeg' });
  }

  isFormChanged(): boolean {
    return JSON.stringify(this.aliasForm.value) !== JSON.stringify(this.initialFormValues);
  }

  checkFileValidation(imageWidth: number, imageHeight: number, imageSize: number) {
    if (imageWidth < this.minImageSize || imageHeight < this.minImageSize) {
      this.imageSizeIsSmall = true;
    } else if (imageSize > this.maxImageSize) {
      this.imageSizeIsLarge = true;
    }

  }
  checkFileType(fileName: string,) {
    const fileExtension = fileName.split(".");
    const extension = fileExtension[fileExtension.length - 1].toLowerCase();
    if (extension != "jpg" && extension != "jpeg" && extension != "png") {
      this.showToast = true
      this._loadingSpinnerService.hide()
      this.toastService.show(ToastType.Error, 'BP_CM_INVALID_IMAGE_FORMAT_MSG', '8%', '40%');
      this.closeCropperModal()
      setTimeout(() => {
        this.toastService.hide();
        this.showToast = false;
        this._cdr.markForCheck();
      }, AppConstants.MIN_TIME_TOASTER);
    }
  }

}
